import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchAfslAndModelAssociations, fetchModelAssociations } from './thunks';
import { ModelAssociations, ModelAssociationsState } from './types';

export const initialState: ModelAssociationsState = {
  modelAssociations: null,
  afslId: undefined,
  afslError: false,
};

export const modelAssociationsSlice = createSlice({
  name: '@@model/associations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    builder.addCase(fetchAfslAndModelAssociations.pending, (state) => {
      state.afslError = false;
    });

    builder.addCase(
      fetchAfslAndModelAssociations.fulfilled,
      (state, action: PayloadAction<number>) => {
        state.afslId = action.payload;
        state.afslError = false;
      }
    );

    builder.addCase(fetchAfslAndModelAssociations.rejected, (state) => {
      state.afslError = true;
    });

    builder.addCase(
      fetchModelAssociations.fulfilled,
      (state, action: PayloadAction<ModelAssociations>) => {
        state.modelAssociations = action.payload;
      }
    );
  },
});

